import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@/components/primitives/Button.jsx';
import Card from '@/components/primitives/Card.jsx';
import Select from '@/components/primitives/Select.jsx';
import getWorkspaceLabel from '@/lib/company/getWorkspaceLabel.js';
import toastManager from '@/lib/toast/toastManager.js';
import switchOrganization from '@/redux/actions/sessionActions/switchOrganization.js';
import { activeCompany, authRole, userCompanies } from '@/redux/selectors/userSelectors.js';
import CreateOrganizationDialog from './CreateOrganizationDialog.jsx';

/** The organization you are working in, your role there, and the way to move to another one. */
const OrganizationSection = () => {
  const dispatch = useDispatch();
  const company = useSelector(activeCompany);
  const role = useSelector(authRole);
  const companies = useSelector(userCompanies);
  const [isCreating, setIsCreating] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  const handleSwitch = async (companyId) => {
    if (!companyId || companyId === company?.id) {
      return;
    }

    setIsSwitching(true);
    const res = await dispatch(switchOrganization({ companyId }));
    setIsSwitching(false);

    if (res?.success === false) {
      toastManager.add({ type: 'error', title: 'Could not switch organization', description: res.message });
    }
  };

  return (
    <div className="settings-stack">
      <Card title="Organization" actions={<Button onClick={() => setIsCreating(true)}>Create organization</Button>}>
        <dl className="settings-facts">
          <dt>Working in</dt>
          <dd>{getWorkspaceLabel(company)}</dd>
          <dt>Your role</dt>
          <dd>{role || 'Member'}</dd>
        </dl>
      </Card>
      {companies.length > 1 && (
        <Card title="Switch organization" description="Connections, knowledge and automations belong to one organization. Switching shows the other one's.">
          <div className="settings-field settings-field--wide">
            <Select label="Organization" items={companies.map((item) => ({ value: item.id, label: getWorkspaceLabel(item) }))} value={company?.id} onValueChange={handleSwitch} disabled={isSwitching} />
          </div>
        </Card>
      )}
      <CreateOrganizationDialog open={isCreating} onOpenChange={setIsCreating} />
    </div>
  );
};

export default OrganizationSection;
